/* eslint-disable @typescript-eslint/default-param-last */
import { ReduxAction } from '../global-states';
import { ReducerState } from './_prototype';

// initial state
export const initialState: ReducerState = {
  busList: [],
  scheduleList: [],
  socket: null,
};

export * from './_prototype';

// constants
export const UPDATE_SOCKET = 'UPDATE_SOCKET';
export const UPDATE_BUS_LIST = 'UPDATE_BUS_LIST';
export const UPDATE_SCHEDULE_LIST = 'UPDATE_SCHEDULE_LIST';

// action reducer
export default function actionReducer(
  state = initialState,
  action: ReduxAction
) {
  switch (action.type) {
    case UPDATE_SOCKET:
      return {
        ...state,
        socket: action.payload,
      };

    case UPDATE_BUS_LIST:
      return {
        ...state,
        busList: action.payload,
      };
    case `${UPDATE_BUS_LIST}_RESET`:
      return {
        ...state,
        busList: [],
      };

    case UPDATE_SCHEDULE_LIST:
      return {
        ...state,
        scheduleList: action.payload,
      };
    case `${UPDATE_SCHEDULE_LIST}_RESET`:
      return {
        ...state,
        scheduleList: [],
      };
    default:
      return state;
  }
}
